import { gql } from 'graphql-tag';

export const getGuidedPractice = gql`
  query guidedPractice($guidedPracticeUserId: ID!) {
    guidedPractice(guidedPracticeUserId: $guidedPracticeUserId) {
      id
      sourceId
      guidedPracticeRelationId
      guidedPracticeRelationItemId
      latestExamPaperId
      latestExamSessionId
      title
      subject
      questionAmount
      articleAmount
      status
    }
  }
`;

export const getGuidedPractices = gql`
  query guidedPractices {
    guidedPractices {
      id
      guidedPracticeUserId
      sourceId
      guidedPracticeRelationId
      guidedPracticeRelationItemId
      latestExamPaperId
      latestExamSessionId
      title
      subject
      questionAmount
      articleAmount
      status
    }
  }
`;

export const getGuidedPracticeExamPaper = gql`
  query guidedPracticeExamPaper($examSessionId: ID!) {
    guidedPracticeExamPaper(examSessionId: $examSessionId) {
      id
      totalQuestions
      fullScore
      score
      status
      createdAt
      updatedAt
      examPaperItemViews {
        __typename
        ... on QuestionExamPaperItem {
          id
          examPaperId
          questionId
          type
          questionType
          metadata {
            choices {
              label
              value
            }
          }
          metadataV2 {
            ... on ExamPaperItemMetadataChoice {
              choices {
                label
                value
              }
            }
            ... on ExamPaperItemMetadataFillNumber {
              precision
            }
            ... on ExamPaperItemMetadataChoiceDifferentScore {
              choices {
                label
                value
              }
            }
            ... on ExamPaperItemMetadataMultipleSelectWithCorrectAnswers {
              choices {
                label
                value
              }
            }
            ... on ExamPaperItemMetadataMultipleSelect {
              choices {
                label
                value
              }
            }
            ... on ExamPaperItemMetadataConnection {
              connectionChoices: choices {
                label
                value
              }
            }
          }
          question
          correctAnswer {
            value
          }
          hint
          solution
          score
          scoreRatio
          examScoreScale
          answer {
            value
          }
          isCorrect
          order
          passage
        }
        ... on ArticleExamPaperItem {
          id
          examPaperId
          articleId
          type
          articleType
          title
          details
          order
        }
      }
    }
  }
`;
